module.exports = __webpack_public_path__ + "static/food-runner-job-description-1d8527359f4e3f841db63dda99612a01.jpg";